import { useState } from "react";
import { api, ApiError, setSession } from "./api";

export default function Login({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    const u = username.trim();
    if (!u || !password) {
      setError("نام کاربری و رمز عبور را وارد کنید.");
      return;
    }
    setBusy(true);
    setError("");
    try {
      const res = await api.login(u, password);
      const session = {
        api_token: res.data.api_token,
        user: res.data.user,
      };
      setSession(session);
      onLogin(session);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "خطا در ورود به سیستم");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-screen">
      <form className="login-card" onSubmit={handleSubmit}>
        <div className="brand-logo-wrap login-logo">
          <img className="brand-logo" src="https://www.motekhassesan.com/wp-content/uploads/2019/10/NEW-LOGOOoO-Copy.png" alt="لوگوی انتشارات متخصصان" />
        </div>
        <h1>ورود به ردیاب بازخورد کارشناسان</h1>
        <p className="login-sub">برای ادامه، نام کاربری و رمز عبور خود را وارد کنید.</p>

        <label className="sr-only" htmlFor="username">نام کاربری</label>
        <input
          id="username"
          className="input"
          autoComplete="username"
          placeholder="نام کاربری"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          disabled={busy}
        />

        <label className="sr-only" htmlFor="password">رمز عبور</label>
        <input
          id="password"
          className="input"
          type="password"
          autoComplete="current-password"
          placeholder="رمز عبور"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          disabled={busy}
        />

        {error && <div className="login-error">{error}</div>}

        <button type="submit" className="btn btn-primary login-submit" disabled={busy}>
          {busy ? "در حال ورود…" : "ورود"}
        </button>
      </form>
    </div>
  );
}
